export class SelectableDatasetModel {
    constructor(dataset) {
        this.selected = false;
        this.showLimits = false;
        this.showLimitsForStringStatus = null;
        this.selected = false;
        this.showLimits = false;
        this.dataset = dataset;
    }
}
